export default {
  "path": "/demo/icon-font-wechat-icon",
  "meta": {
    "name": "demo-企业微信icon组件",
    "title": "WechatIcon 企业微信icon组件",
    "isComponentDoc": true,
    "category": "Basic"
  }
};